// extracted by mini-css-extract-plugin
module.exports = {"universalTable":"main_universalTable__1lA8d"};